import { useLocation } from "react-router-dom";

export const getBuyHeaderText = (params) => {
  const sale_type = params.get("sale_type");
  const category = params.get("category");
  const open_house = params.get("open_house") || "false";

  const formatText = (text) =>
    text
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const saleTypeTextMap = {
    standard: "Homes for Sale",
    foreclosure: "Foreclosures",
    fsbo: "For Sale by Owner",
    new_construction: "New Construction",
    coming_soon: "Coming Soon",
    recent_sale: "Recent Sales"
  };

  let headingText = "Homes for Sale";

  // Category takes precedence
  if (category) {
    headingText = `${formatText(category)}s for Sale`;
  } else if (sale_type && saleTypeTextMap[sale_type]) {
    headingText = saleTypeTextMap[sale_type];
  }

  if (open_house === "true") {
    headingText += " - Open House";
  }

  return headingText;
};

const BuyHeader = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const headingText = getBuyHeaderText(params);

  return <h6 className="mb-0">{headingText}</h6>;
};

export default BuyHeader;
